import { createDelivery, fetchDeliveries, fetchDelivery, getDashboardData } from './asyncThunks';

export const getDashboardDataBuilder = builder => {
  builder.addCase(getDashboardData.pending, state => {
    state.getDashboardDataPending = true;
  });
  builder.addCase(getDashboardData.fulfilled, (state, action) => {
    state.getDashboardDataPending = false;
    const { data } = action.payload;
    state.dashboardData = data;
  });
  builder.addCase(getDashboardData.rejected, state => {
    state.getDashboardDataPending = false;
  });
};

export const createDeliveryBuilder = builder => {
  builder.addCase(createDelivery.pending, state => {
    state.createDeliveryPending = true;
  });
  builder.addCase(createDelivery.fulfilled, (state, action) => {
    state.createDeliveryPending = false;
    const { data } = action.payload;
    state.deliveries.data = [data, ...state.deliveries.data];
  });
  builder.addCase(createDelivery.rejected, state => {
    state.createDeliveryPending = false;
  });
};

export const fetchDeliveriesBuilder = builder => {
  builder.addCase(fetchDeliveries.pending, state => {
    state.fetchDeliveriesPending = true;
  });
  builder.addCase(fetchDeliveries.fulfilled, (state, { payload }) => {
    state.fetchDeliveriesPending = false;
    const { data, maxReached, page, total, perPage } = payload.data;

    state.deliveries.data = data;
    state.deliveries.maxReached = maxReached;
    state.deliveries.total = total;
    state.deliveries.page = page;
    state.deliveries.perPage = perPage;
  });
  builder.addCase(fetchDeliveries.rejected, state => {
    state.fetchDeliveriesPending = false;
  });
};

export const fetchDeliveryBuilder = builder => {
  builder.addCase(fetchDelivery.pending, state => {
    state.fetchDeliveryPending = false;
  });
  builder.addCase(fetchDelivery.fulfilled, (state, { payload }) => {
    const data = payload.data;
    state.selectedDelivery = data;
    state.fetchDeliveryPending = false;
  });
  builder.addCase(fetchDelivery.rejected, state => {
    state.fetchDeliveryPending = false;
  });
};
